import { useQuery, useQueryClient } from '@tanstack/react-query';
import { ApiCalls } from '../../api/api';
import { ALL_PERIODS, CURRENT_PERIOD } from '../../constants/queryKeys';
import { useRef } from 'react';
import { Period, ReportPeriodDto } from '../../api/generated/data-contracts';
import { fromMinutes } from '../../_helpers/milliseconds';

export const useGetCurrentPeriod = (date: string) => {
    const defaultData = useRef({} as ReportPeriodDto).current;
    const queryClient = useQueryClient();

    const { data: currentPeriod = defaultData, isLoading } = useQuery(
        [CURRENT_PERIOD, date],
        () => ApiCalls.getUserPeriodByDate({ date }).then(res => res.data),
        {
            onSuccess(data) {
                if (data) {
                    const allPeriods = queryClient.getQueryData<Period[]>([ALL_PERIODS]);

                    const newPeriod = allPeriods?.find(f => f.id === data.reportPeriod.periodId);

                    if (!newPeriod) {
                        const period: Period = {
                            id: data.reportPeriod.periodId,
                            name: data.reportPeriod.name,
                            startDate: data.reportPeriod.startDate,
                            endDate: data.reportPeriod.endDate,
                            state: 'Open',
                            deadlineDate: data.reportPeriod.deadlineDate,
                        };

                        queryClient.setQueryData<Period[]>([ALL_PERIODS], prevState => {
                            return [...(prevState ?? []), period];
                        });
                    }
                }
            },
        },
    );

    return { currentPeriod, isLoading };
};
